<template>
  <div>
    <div
      id="add-contact-name"
      :class="{ 'show-full-list': showFullResultList }"
    >
      <!-- Form -->
      <form class="common-form">
        <div class="form-group">
          <label for="contact-name">Name</label>
          <span class="icon-search-contacts">
            <img
              src="../../../../assets/svg/search-icon-input.svg"
              type="image/svg+xml"
            />
          </span>
          <input
            type="text"
            class="form-control"
            id="contact-name"
            autocomplete="off"
            @focus="showResult"
            :value="searchTerm"
            @input="updateSearchTerm($event.target.value)"
            @keypress="updateSearchTerm($event.target.value)"
            @keyup.esc="updateSearchTerm('')"
          />
          <span class="icon-close-search">
            <img
              class="cursor-pointer"
              src="../../../../assets/img/icon-close.png"
              type="image/svg+xml"
              @click="hideResult"
            />
          </span>
        </div>
        <div class="add-contact-link">
          <p @click="directAddContact">Add Contact</p>
        </div>
      </form>

      <!-- Result list -->
      <result-list
        :show="(show && searchTerm.length > 0) || addContact"
        :term="searchTerm"
        :hide-result="hideResult"
        :add-contact="addContact"
        :empty-term="emptyTerm"
        :add-option-selected="addOptionSelected"
        :toggle-full-result-list="toggleFullResultList"
        :show-full-result-list="showFullResultList"
      />

      <!-- Full list -->
      <full-list
        v-if="showFullResultList"
        :hide-full-result-list="hideFullResultList"
        :hide-result="hideResult"
      />
    </div>
  </div>
</template>

<script>
import ResultList from "./AddContact/ResultList";
import FullList from "./AddContact/FullList";
import { mapMutations } from "vuex";
import { providerDependentMixin } from "../../../../mixins/providerDependentMixin";

export default {
  name: "AddContactUnified",
  mixins: [providerDependentMixin],
  props: {
    addOptionSelected: Function // When add client/person/event/group option is selected
  },
  data() {
    return {
      addContact: false, // Wheather to show the add contact or not
      searchTerm: "", // The term we are currently trying to search
      show: false, // Show the result or not
      showFullResultList: false //Show the full result list
    };
  },
  components: {
    ResultList, // The result list
    FullList // The full list
  },
  methods: {
    ...mapMutations({
      setAppointmentType: "setAppointmentType"
    }),
    /**
     * Show the result
     */
    showResult() {
      this.show = true;
    },
    /**
     * Hides the result
     */
    hideResult() {
      this.addContact = false;
      if (this.show === true) {
        return (this.show = false);
      }
      this.searchTerm = "";
    },
    /**
     * Empty the search term
     */
    emptyTerm() {
      this.searchTerm = "";
    },
    /**
     * Updates the search term
     */
    updateSearchTerm(value) {
      this.searchTerm = value;
      this.hideFullResultList();
    },
    /**
     * Add contact directly
     */
    directAddContact() {
      this.addContact = true;
      this.show = true;
    },
    /**
     * Toggle the full list
     */
    toggleFullResultList() {
      this.showFullResultList = !this.showFullResultList;
    },
    /**
     * Hide the full result list
     */
    hideFullResultList() {
      this.showFullResultList = false;
    }
  },
  watch: {
    /**
     * When the selected value is updated
     * Change the search term
     * Select video for video group
     */
    selectedValue({ name }) {
      if (name) {
        this.searchTerm = name.replace(/&amp;/g, "&").replace(/&amp;/g, "&");
        this.addContact = false;
        if (this.show === true) {
          this.show = false;
        }
      }
    },
    /**
     * When search term is not equal to the selected name, then we reset the selection
     */
    searchTerm(value) {
      if (
        value !==
        this.selectedName.replace(/&amp;/g, "&").replace(/&amp;/g, "&")
      ) {
        this.setAppointmentType({
          selectedId: 0,
          selectedType: ""
        });
      }
    }
  },
  /**
   * Updating the search term if there is some name
   */
  created() {
    this.searchTerm = this.selectedName
      .replace(/&amp;/g, "&")
      .replace(/&amp;/g, "&");
  }
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

#add-contact-name {
  width: 98%;
  margin: 20px auto;
}

#add-contact-name.show-full-list {
  width: 100% !important;
  margin: 0 auto !important;
  position: absolute;
  z-index: 999999;
  min-height: 100%;
  background: #fff;
}

#add-contact-name form {
  padding: 15px 10px 20px;
  background: #ededed;
  border: 1px solid #d7d7d7;
  border-radius: 5px;
}

#add-contact-name form label {
  display: block;
  margin-bottom: 5px;
}

#add-contact-name input {
  width: calc(100% - 60px);
  padding: 0 30px;
  height: 34px;
  position: relative;
}

#add-contact-name .form-group {
  position: relative;
}

.icon-search-contacts,
.icon-close-search {
  display: inline-block;
  width: 20px;
  position: absolute;
  top: 30px;
  left: 8px;
  height: 20px;
  z-index: 999;
}

.icon-close-search {
  right: 8px;
  left: unset;
}

.icon-search-contacts img,
.icon-close-search img {
  width: 80%;
}

.common-form input {
  border: 1px solid #e3e9ef;
  font-size: 16px;
  -webkit-appearance: textfield;
  background-color: #fff;
  -webkit-rtl-ordering: logical;
  cursor: text;
  color: #595959;
  padding: 7px 5px;
  width: 98%;
  display: block;
}

div >>> .search-result-for-contacts {
  background: #fff;
  border: 1px solid #e3e9ef;
  padding: 10px 15px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  position: relative;
  top: -14px;
}

div >>> .sr-list {
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 14px;
}

div >>> .sr-list li {
  margin: 0;
  border-bottom: 1px solid #e3e9ef;
  padding: 15px 0;
}

div >>> .sr-list li:hover {
  color: #e56700;
}

div >>> .sr-list li:last-child {
  border: none;
}

.search-result-for-contacts .container {
  justify-content: left !important;
}

.add-contact-link {
  display: flex;
  flex-direction: row-reverse;
  margin-right: 10px;
  margin-top: 10px;
}

.add-contact-link p {
  font-size: 11px;
  color: #e56700;
  cursor: pointer;
}
</style>
